var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_2428_63426)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_63426)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 45C36.0457 45 45 36.0457 45 25C45 13.9543 36.0457 5 25 5C13.9543 5 5 13.9543 5 25C5 36.0457 13.9543 45 25 45Z",
    fill: "#FA5562"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1612 29.5514C19.2127 29.3734 19.2401 29.1894 19.2427 29.0042C19.2427 28.4478 19.0217 27.9142 18.6282 27.5207C18.2348 27.1273 17.7012 26.9062 17.1448 26.9062C16.5884 26.9062 16.0548 27.1273 15.6613 27.5207C15.2679 27.9142 15.0469 28.4478 15.0469 29.0042C15.0495 29.1894 15.0769 29.3734 15.1284 29.5514H19.1612Z",
    fill: "#CCA332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1846 29.5514C34.2361 29.3734 34.2635 29.1894 34.2661 29.0042C34.2661 28.4478 34.0451 27.9142 33.6517 27.5207C33.2582 27.1273 32.7246 26.9062 32.1682 26.9062C31.6118 26.9062 31.0782 27.1273 30.6848 27.5207C30.2913 27.9142 30.0703 28.4478 30.0703 29.0042C30.0729 29.1894 30.1004 29.3734 30.1518 29.5514H34.1846Z",
    fill: "#CCA332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2959 36.6526C16.2273 36.6525 16.1604 36.6311 16.1044 36.5914C16.0485 36.5516 16.0063 36.4955 15.9835 36.4307C15.9608 36.366 15.9588 36.2958 15.9776 36.2298C15.9965 36.1638 16.0353 36.1053 16.0888 36.0623C25.4016 28.5955 32.7147 36.0155 32.7869 36.0914C32.8431 36.1556 32.8724 36.2389 32.8688 36.3242C32.8651 36.4094 32.8287 36.49 32.7672 36.5491C32.7056 36.6082 32.6237 36.6413 32.5384 36.6416C32.4531 36.6419 32.3709 36.6092 32.309 36.5505C32.0279 36.2591 25.335 29.4969 16.5039 36.5795C16.4449 36.6268 16.3715 36.6526 16.2959 36.6526Z",
    fill: "#CCA332"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2428_63426",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_63426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadIconSvg);
export default __webpack_public_path__ + "static/media/sad-icon-svg.223cb18b3f6cecdb9a673e96d744d05a.svg";
export { ForwardRef as ReactComponent };